function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu04Purple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "menu-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.75 15H26.25M3.75 7.5H26.25M11.25 22.5H26.25",
    stroke: "#0B2E78",
    style: {
      stroke: "#0B2E78",
      stroke: "color(display-p3 0.0428 0.1819 0.4716)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu04Purple);
export default __webpack_public_path__ + "static/media/menu-04-purple.badcd7d65b7f3ba2e0cfd76ac6ee5d7b.svg";
export { ForwardRef as ReactComponent };